import { Link } from "react-router-dom";
import type { Task } from "../types";

interface TaskCardProps {
  task: Task;
  onStatusChange?: (id: string, status: Task["status"]) => void;
}

const statusColors: Record<Task["status"], string> = {
  todo: "bg-yellow-900/40 text-yellow-300",
  "in-progress": "bg-blue-900/40 text-blue-300",
  done: "bg-green-900/40 text-green-300",
};

const priorityDots: Record<Task["priority"], string> = {
  critical: "bg-red-400",
  high: "bg-orange-400",
  medium: "bg-yellow-400",
  low: "bg-green-400",
};

export function TaskCard({ task, onStatusChange }: TaskCardProps) {
  return (
    <Link
      to={`/task/${task.id}`}
      className="block bg-dark-800 border border-dark-600 rounded-lg p-4 hover:border-dark-400 transition-colors"
    >
      <div className="flex items-start justify-between">
        <div className="flex items-center gap-2">
          <span className={`w-2 h-2 rounded-full ${priorityDots[task.priority]}`} />
          <h3 className="text-white font-medium text-sm">{task.title}</h3>
        </div>
        <span className={`px-2 py-0.5 rounded text-xs ${statusColors[task.status]}`}>
          {task.status}
        </span>
      </div>

      <p className="text-dark-400 text-xs mt-2 line-clamp-2">{task.description}</p>

      <div className="flex items-center justify-between mt-3">
        <div className="flex gap-1">
          {task.tags.map((tag) => (
            <span key={tag} className="bg-dark-700 text-dark-300 px-1.5 py-0.5 rounded text-xs">
              {tag}
            </span>
          ))}
        </div>
        <span className="text-dark-500 text-xs">{task.assignee}</span>
      </div>
    </Link>
  );
}
